import { render, staticRenderFns } from "./EditAmountPopup.vue?vue&type=template&id=2596affb&scoped=true&"
import script from "./EditAmountPopup.vue?vue&type=script&lang=js&"
export * from "./EditAmountPopup.vue?vue&type=script&lang=js&"
import style0 from "./EditAmountPopup.vue?vue&type=style&index=0&id=2596affb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596affb",
  null
  
)

export default component.exports